import React from 'react';
import { useTranslation } from "react-i18next";
import { Button, Tooltip, useTheme, CircularProgress } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export const ExportDropdown = ({
  onPngExport,
  isExporting,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const buttonStyles = {
    minWidth: '40px',
    height: '32px',
    borderColor: theme.palette.grey[300],
    color: 'rgb(48,122,215)',
    '&:hover': {
      backgroundColor: 'rgba(48,122,215,0.1)',
      borderColor: 'rgb(48,122,215)'
    }
  };

  if (isExporting) {
    return (
      <Button
        variant="outlined"
        size="small"
        disabled
        sx={buttonStyles}
      >
        <CircularProgress size={16} sx={{ color: 'rgb(48,122,215)' }} />
      </Button>
    );
  }

  return (
    <Tooltip title={t("label.exportAsPng")}>
      <Button
        variant="outlined"
        size="small"
        onClick={onPngExport}
        sx={buttonStyles}
      >
        <FileDownloadIcon fontSize="small" />
      </Button>
    </Tooltip>
  );
};
